mutation UpdateUserPasswordFromSecretToken($secretToken: String!, $newPassword: String!) {
  updateUserPasswordFromSecretToken(secretToken: $secretToken, newPassword: $newPassword) {
    ok
    errors
  }
}
